module.exports = __webpack_public_path__ + "img/Instagram.1b787d7f.svg";